import React, { useState } from "react";
import { AiOutlineSearch } from 'react-icons/ai';

import Accordion from "components/layout/Accordion";
import OutlinedButton from "components/layout/form/outlinedButton";
import TextField from "components/layout/form/textField";

import {
  Content,
  ContentFilter,
  NotResults,
  ButtonContainer,
} from "./styles";

const itemsBase = [
  {
    title: 'O que fazer se estou chegando ao imóvel?',
    body: (
      <>
        <p>
          Ao entrar em um imóvel com Medição Individualizada da Ultragaz, você precisa realizar o <a href="/primeiro-acesso-mi">primeiro acesso</a> ao Portal Minha Ultragaz, usando o CPF do titular da conta.
        </p>
        <p>
          Automaticamente, será gerada uma solicitação de primeira leitura. Caso o abastecimento de sua unidade tenha sido suspenso pelo morador anterior, o fornecimento de gás será liberado em até 3 dias úteis. Se o abastecimento estiver ativo, será feita a leitura inicial para que, na próxima leitura, seja realizada a cobrança dos dias de consumo a partir do seu primeiro acesso.
        </p>
        <p>
          Se você já possui cadastro no portal, <a href="/">faça o login</a> e acesse <b>adicionar nova unidade</b> no menu lateral esquerdo. Siga os passos e pronto, o seu imóvel passará pela primeira leitura e terá o gás liberado.
        </p>
      </>
    ),
  },
  {
    title: 'O que fazer se estou saindo do imóvel?',
    body: (
      <>
        <p>
          Ao sair do imóvel, é preciso que você solicite o <b>desligamento do gás</b> ou que o novo morador da unidade faça o <b>primeiro acesso</b> ao Portal Minha Ultragaz.
        </p>
        <p>
          Para pedir o desligamento do seu gás, acesse o <a href="/">Portal Minha Ultragaz</a> e clique em <b>desligar gás</b>. O imóvel terá o gás suspenso, e a unidade não terá mais o seu nome como responsável.
        </p>
        <p>
          Quando o novo morador realizar o <a href="/primeiro-acesso-mi">primeiro acesso</a> no Portal Minha Ultragaz, haverá a troca de titularidade e será feita a primeira leitura. Assim, a próxima fatura já virá em nome do novo morador.
        </p>
      </>
    ),
  },
  {
    title: 'Como solicitar o desligue de fornecimento por saída do imóvel?',
    body: (
      <>
        <p>
          Ao sair do imóvel, é preciso que você solicite o <b>desligamento do gás</b> ou que o novo morador da unidade faça o primeiro acesso ao Portal Minha UItragaz. O desligamento da sua unidade encerra o serviço prestado em seu nome.
        </p>
        <p>
          Para restabelecer o consumo, o novo morador deverá realizar o primeiro acesso no portal. A ligação da unidade será executada em até 3 dias úteis.
        </p>
        <p>
          Para pedir o desligue de fornecimento, vá em <b>Ligar e Desligar Gás</b> e em <a href="religue">solicitar desligue de fornecimento por saída do imóvel</a>.
        </p>
      </>
    ),
  },
  {
    title: 'Como solicitar a ligação de fornecimento da unidade de um novo morador?',
    body: (
      <>
        <p>
        Depois de realizar o primeiro acesso ao Portal Minha Ultragaz, a ligação de fornecimento da unidade será solicitada automaticamente. Para realizar o ligue de uma nova unidade que ainda não está em seu nome, clique em <a href="adicionar-unidade">Adicionar nova unidade</a> e a ligação será solicitada automaticamente.
        </p>
        <p>
          Para retomar uma unidade que já esteve em seu nome, entre em contato com o nosso atendimento:
        </p>
        <p>Regiões metropolitanas: 4003-1616</p>
        <p>Demais regiões: 0800-886-1616</p>
      </>
    ),
  },
  {
    title: 'Como funciona o bloqueio de fornecimento por inadimplência?',
    body: (
      <>
        <p>
          O bloqueio é feito pela Ultragaz quando um boleto está vencido há mais de 20 dias corridos, contando a partir da data de vencimento.
        </p>
        <p>
          Quando o boleto for pago e a compensação bancária for confirmada, em aproximadamente 3 dias úteis, a ordem de religue é realizada automaticamente em até 2 dias úteis.
        </p>
        <p>
          Ao realizar o pagamento, você pode, também, <a href="/religue">solicitar o religue de fornecimento</a>.
        </p>
        <p>
          Não há custo para o <b>Bloqueio de fornecimento por inadimplência</b>, mas, para o <a href="/religue">Religue de fornecimento</a>, serão cobrados R$60,00 no boleto seguinte à execução do serviço.
        </p>
      </>
    ),
  },
  {
    title: 'Como solicitar religue de fornecimento?',
    body: (
      <>
        <p>
          A solicitação de religue pode ser feita tanto em caso de <b>Bloqueio de fornecimento por inadimplência</b> ou de <b>Bloqueio temporário de fornecimento</b>.
        </p>
        <p>
          O prazo para execução do religue do seu gás é de até 5 dias úteis. No próximo boleto, serão cobrados R$60,00 por esse serviço.
        </p>
        <p>
          <b>Importante:</b>
          <ul>
            <li>
              Verifique se há algum boleto pendente de pagamento. Caso haja alguma pendência, você pode gerar, aqui mesmo, pelo Portal Minha Ultragaz, a 2ª via do seu boleto e realizar o pagamento imediatamente.
            </li>
            <li>
              É importante que, no dia da visita para o religue, o responsável pela unidade e/ou condomínio esteja no local para liberar o acesso da nossa equipe técnica.
            </li>
            <li>
              Para que o religue seja realizado no medidor correto, é preciso que o número da unidade esteja visível e legível. Caso a equipe técnica encontre alguma divergência, o serviço não será executado.
            </li>
            <li>
              Medidores com avarias, como ilegibilidade, visor embaçado ou falta de proteção, não poderão ser religados. Nesses casos, será necessária a substituição do equipamento. Temos fornecedores homologados que poderão auxiliar você. Pergunte para a Ully como entrar em contato com eles.
            </li>
            <li>
              Para preservar a sua segurança, a nossa equipe técnica não vai liberar a válvula para a passagem do gás. Com a finalização da prestação do serviço, assim que possível, verifique o <a href="/religue">registro abre e fecha</a>, localizado no seu medidor, e libere a passagem do gás.
            </li>
          </ul>
        </p>
      </>
    ),
  },
  {
    title: 'O que fazer se solicitei o religue e continuo sem gás?',
    body: (
      <>
        <p>
          Para preservar a sua segurança, a nossa equipe técnica não libera a válvula para a passagem do gás. Com a finalização do serviço, assim que possível, verifique o <a href="/religue">registro abre e fecha</a>, localizado no seu medidor, e libere a passagem do gás.
        </p>
        <p>
          Se ainda assim estiver sem gás, entre em contato com a <a href="#" onClick={() => openUlly()}>Ully</a> para que enviemos um técnico à sua unidade.
        </p>
      </>
    ),
  },
  {
    title: 'Como solicitar bloqueio temporário de fornecimento?',
    body: (
      <>
        <p>
          Você pode bloquear o fornecimento de gás da sua unidade por motivo de viagem ou obras e, depois, retomar o abastecimento em seu nome.
        </p>
        <p>
          Para solicitar esse serviço, é preciso que os <a href="/consulta-debitos">boletos</a> estejam pagos. Verifique, no Portal Minha Ultragaz, se há boletos em aberto e realize o pagamento antes de solicitar o bloqueio temporário de fornecimento.
        </p>
        <p>
          Não é cobrado o serviço de <b>Bloqueio temporário de fornecimento</b>, mas, para o <b>Religue de fornecimento</b>, serão cobrados R$60,00 pelo serviço, no boleto seguinte.
        </p>
      </>
    ),
  },
  {
    title: 'Como funciona o período do consumo?',
    body: (
      <p>
        O período de consumo é a quantidade de dias que decorreram entre as leituras do medidor. Trabalhamos para que, todo mês, esse período fique entre 28 a 32 dias. No seu boleto você pode verificar os dias de consumo e as datas em que as leituras foram realizadas. Para mais detalhes, confira, no Portal, o campo <a href="/consumo">entenda sua conta</a>.
      </p>
    ),
  },
  {
    title: 'Como funciona o valor cobrado por kg do gás?',
    body: (
      <p>
        O valor do kg de GLP é negociado de forma centralizada com o síndico, zelador ou administradora do seu condomínio. Você pode acompanhar essa informação pela sua conta no campo Vlr.Unit.R$. Para mais detalhes, confira, no Portal, o campo <a href="/consumo">entenda sua conta</a>.
      </p>
    ),
  },
  {
    title: 'O que é o fator de conversão?',
    body: (
      <p>
        É o valor utilizado para transformar a unidade de medida de consumo de gás em unidade de venda. O gás é medido em metros cúbicos (m³), mas é vendido em quilogramas (kg).
      </p>
    ),
  },
  {
    title: 'O que é medição individual?',
    body: (
      <p>
        É o modelo de cobrança que a Ultragaz disponibiliza para condôminos. Nela, a cobrança é realizada de acordo com o volume consumido em sua unidade no período de leitura - uma cobrança individual para cada morador.
      </p>
    ),
  },
  {
    title: 'Como solicito assistência técnica aos fornecedores parceiros da Ultragaz?',
    body: (
      <p>
        Lembramos que a assistência técnica da central de gás é de responsabilidade da Ultragaz. Já a manutenção de medidor, mangueira, fogão e outros queimadores deve ser feita pelo morador. Para garantir sua segurança, recomendamos que sejam chamados nossos fornecedores parceiros. Para solicitar um orçamento e visita, entre em contato com a nossa central de atendimento.
      </p>
    ),
  },
  {
    title: 'Como solicito carta de nada consta, certidão negativa de débitos?',
    body: (
      <p>
        Você pode fazer a sua solicitação por meio do nosso WhatsApp (11) 93305-8481. Se preferir, faça o pedido à <a href="#" onClick={() => openUlly()}>Ully</a>.
      </p>
    ),
  },
  {
    title: 'Como solicito parcelamento de fatura?',
    body: (
      <p>
        Você pode solicitar o parcelamento da sua fatura à nossa central de atendimento, pelo WhatsApp (11) 93305-8481. Vamos avaliar o seu pedido e daremos retorno em 5 dias úteis.
      </p>
    ),
  },
  {
    title: 'Recebi uma nota fiscal por e-mail. Do que se trata?',
    body: (
      <p>
        A nota fiscal é referente ao seu consumo de GLP. Depois da nota, será enviado o boleto para pagamento.
      </p>
    ),
  },
  {
    title: 'Como solicito nota fiscal para a Ultragaz?',
    body: (
      <p>
        Você pode solicitar o envio da nota fiscal à nossa central de atendimento, pelo WhatsApp (11) 93305-8481. Se preferir, faça o pedido à <a href="#" onClick={() => openUlly()}>Ully</a>.
      </p>
    ),
  },
  {
    title: 'Realizei o pagamento do meu boleto e ainda consta como não pago no portal. Por quê?',
    body: (
      <>
        <p>
          A compensação bancária do pagamento do boleto leva, em média, 3 dias úteis. Somente depois da compensação a Ultragaz recebe a informação do banco de que o boleto foi pago. Feita a confirmação, nossos sistemas atualizam o status do seu boleto no portal.
        </p>
      </>
    ),
  },
  {
    title: 'Como altero o endereço em que recebo o boleto do gás (endereço de correspondência)?',
    body: (
      <>
        <p>
          <a href="/preferencia-cobranca">Você pode clicar aqui</a> para alterar o endereço de correspondência do seu boleto que entregue é via correios.
        </p>
        <p>
          #ficaadica: Que tal mudar para a fatura para digital? É mais prático, seguro e sustentável!
        </p>
      </>
    ),
  },
  {
    title: 'Fiz o pagamento do boleto em duplicidade. O que devo fazer?',
    body: (
      <p>
        Fique tranquilo! Após a identificação da duplicidade de pagamento, nosso sistema gera um crédito automaticamente, que virá no próximo boleto.
      </p>
    ),
  },
  {
    title: 'Como realizo o pagamento de um boleto já vencido?',
    body: (
      <p>
        Como se trata de conta de consumo, o boleto pode ser pago após o vencimento em qualquer correspondente bancário. Os juros e a multa serão calculados e aplicados no próximo boleto.
      </p>
    ),
  },
  {
    title: 'Recebi um boleto sem consumo (zerado) o que fazer?',
    body: (
      <>
        <p>
          Seu boleto pode vir zerado por dois motivos:
          <ol>
            <li>
              Consumo inferior a meio kg de gás.
            </li>
            <li>
              Medidor travado.
            </li>
          </ol>
        </p>
        <p>
          Como se trata de conta de consumo, o boleto pode ser pago após o vencimento em qualquer correspondente bancário. Os juros e a multa serão calculados e aplicados no próximo boleto.
        </p>
      </>
    ),
  },
];

const openUlly = () => {
  const chatbotButton = document?.querySelector('#hi-custom-widget');
  chatbotButton && chatbotButton.click();
};

const FAQFaleConosco = ({ setPage }) => {
  const [items, setItems] = useState(itemsBase);

  const onChangeFilter = ({ target: { value }}) => {
    const result = itemsBase?.filter((item) => item?.title?.toLowerCase()?.includes(value?.toLowerCase()));
    setItems(result);
  }

  return (
    <Content>
      <ContentFilter>
        <TextField
          onChange={onChangeFilter}
          LeadingIcon={() => <AiOutlineSearch />}
          placeholder="Digite algo para filtrar"
          label="Digite algo para filtrar"
        />
      </ContentFilter>
      {items?.length ? (
        <Accordion
          items={items}
        />
      ) : (
        <NotResults>
          <span>Não existe nenhum resultado para essa busca</span>
        </NotResults>
      )}
      <ButtonContainer>
        <OutlinedButton onClick={() => setPage('inicio')}>
          Voltar
        </OutlinedButton>
      </ButtonContainer>
    </Content>
  );
};

export default FAQFaleConosco;
